import { defineMessages } from "react-intl";

const messages = defineMessages({
    and: {
        id: "general.and",
    },
    voicesWanted: {
        id: "choir.wanterVoices",
    },
});

export default messages;
